import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { MAX_VISIBLE_CHIPS } from "./chip.const";

// Counterpart to `visibleChips`: takes the full selection and renders the
// remainder the pipe cut off.
@Component({
  selector: "app-chip-overflow",
  template: `+ {{ hiddenCount() }} more`,
  styleUrls: ["./chip-overflow.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "[class.has-overflow]": "0 < hiddenCount()" },
})
export class ChipOverflowComponent {
  readonly items = input<unknown[] | null | undefined>([]);
  readonly visibleCount = input(MAX_VISIBLE_CHIPS);

  readonly hiddenCount = computed(
    () => (this.items()?.length ?? 0) - this.visibleCount(),
  );
}
